import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Badge } from "@/components/Badge";
import { Icon } from "@/components/Icon";

import { ISingleFeature } from "../types";

export const SingleFeature: React.FC<ISingleFeature> = ({
  title,
  text,
  iconType,
}) => {
  const { css } = useFela();
  const { colors, bp } = useTheme();

  const background = `
    linear-gradient(53deg, 
    ${colors.GRADIENT_BLUE_DARK} -14%, ${colors.GRADIENT_PURPLE} 134%)`;

  return (
    <div
      className={css({
        flex: 1,
        color: colors.WHITE,
        nested: {
          ":not(:first-of-type)": {
            [bp.ONLY_MOBILE]: { marginTop: 25 },
            [bp.ONLY_TABLET]: { marginTop: 35 },
          },
        },
        [bp.FROM_TABLET]: {
          margin: "0 auto",
          textAlign: "center",
        },
        [bp.FROM_DESKTOP]: {
          maxWidth: 280,
          textAlign: "left",
        },
      })}
    >
      <div
        className={css({
          display: "flex",
          alignItems: "center",
          [bp.ONLY_TABLET]: {
            justifyContent: "center",
          },
        })}
      >
        <Badge
          customStyle={{
            background,
            marginRight: 20,
            color: colors.WHITE,
            flexShrink: 0,
            [bp.ONLY_MOBILE]: {
              width: 40,
              height: 40,
            },
          }}
        >
          <Icon iconType={iconType} />
        </Badge>

        <h3
          className={css({
            margin: 0,
            fontSize: 20,
            letterSpacing: "1px",
            fontFamily: "'Nunito', sans-serif",
            [bp.FROM_TABLET]: {
              fontSize: 24,
            },
          })}
        >
          {title}
        </h3>
      </div>

      <p
        className={css({
          marginTop: 10,
          fontSize: 16,
          lineHeight: "28px",
          letterSpacing: "0.75px",
          [bp.FROM_TABLET]: {
            fontSize: 18,
            marginTop: 15,
          },
        })}
      >
        {text}
      </p>
    </div>
  );
};
